import React from "react";
import styled from "styled-components";

const Wrapper = styled.h2`
  margin-bottom: 2rem;
`;

const FormHeader = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default FormHeader;
